/**
 * Request
 * @description Axios instance
 * @author Zhong Li
 * @version 1.0.0
 * @since v1.0.0
 */
import axios from "axios";
import { Message } from "element-ui";
import { getAuthToken, removeAuthToken } from "@/cookie/auth";
import router from "../router/index";

axios.defaults.headers["Content-Type"] = "application/json;charset=utf-8";

/* Axios instance */
const request = axios.create({
  /* Base url */
  baseURL: process.env.VUE_APP_API_BASE_URL,
  /* Timeout */
  timeout: 300000,
});

/* Request interceptors */
request.interceptors.request.use(
  (config) => {
    if (getAuthToken()) {
      config.headers.Authorization = getAuthToken();
    }
    return config;
  },
  () => {
    Message.error("Initiating request exception");
  }
);

/* Response interceptors */
request.interceptors.response.use(
  (res) => {
    if (res.data.code === 200) {
      return res.data;
    } else if (res.data.code === 401) {
      removeAuthToken();
      Message.error(res.data.msg);
      router.push("/login");
      return Promise.reject(res.data);
    } else if (res.data.code === 500) {
      Message.error(res.data.msg);
      return Promise.reject(res.data);
    } else {
      return res.data;
    }
  },
  (error) => {
    if (error.response.status === 401) {
      removeAuthToken();
      Message.error(error.response.data.msg);
      router.push("/login");
      return Promise.reject(error);
    } else {
      Message.error(JSON.stringify(error));
      return Promise.reject(error);
    }
  }
);

export default request;
